// ActionList.jsx — Task 11 artifact slot. Numbered recommended next steps.
// Props: { title?, items:[{ text } | string] } — items tolerate a bare string or a {text} object.
import React from "react"

function itemText(it) {
  if (typeof it === "string") return it
  return it && typeof it === "object" ? String(it.text == null ? "" : it.text) : ""
}

export default function ActionList({ title, items }) {
  if (!Array.isArray(items) || items.length === 0) return null
  return (
    <div className="afq-card" data-slot="action_list">
      <div className="afq-card-h"><h2>{title || "Recommended next steps"}</h2></div>
      <ol className="afq-actions">
        {items.map((it, i) => (
          <li key={i}><span className="afq-action-n">{i + 1}</span><span>{itemText(it)}</span></li>
        ))}
      </ol>
    </div>
  )
}
